/**
 * BillingWalletApi
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { SettlementReason } from './settlementReason';
import { TransactionType } from './transactionType';

export interface SettlementDto { 
    transactionNote?: string;
    amount?: number;
    walletId?: string;
    clientResourceId?: string;
    resourceId?: string;
    reason?: SettlementReason;
    transactionType?: TransactionType;
}